import * as types from "./types";

const getters = {
  [types.IS_IN_STORAGE](state) {
    return componentName => {
      const sizes = Object.keys(state.recipes);
      if (!sizes.length) return false;
      return sizes.some(bucketSize => state.recipes[bucketSize][componentName]);
    };
  },
  [types.GET_SIZE](state) {
    return componentName => {
      let size = false;
      const sizes = Object.keys(state.recipes);
      if (!sizes.length) return size;
      for (let i = 0; i < sizes.length; i++) {
        let ugcRecipe = state.recipes[sizes[i]];
        if (
          ugcRecipe &&
          ugcRecipe[componentName] &&
          ugcRecipe[componentName].size
        ) {
          size = ugcRecipe[componentName].size;
          break;
        }
      }
      return size;
    };
  },
  [types.GET_STORAGE_RECIPES](state) {
    return state.recipes;
  }
};

export default getters;
